import { render } from "./TotalGeneralHoras.vue?vue&type=template&id=03b88d79"
import script from "./TotalGeneralHoras.vue?vue&type=script&lang=js"
export * from "./TotalGeneralHoras.vue?vue&type=script&lang=js"

import "./TotalGeneralHoras.vue?vue&type=style&index=0&id=03b88d79&lang=css"

import exportComponent from "/Users/alexnovoa/Documents/PersonalDrive/proyectos-vue/exclusiones-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__